import { DriveStep } from 'driver.js';

export const TOUR_VERSION = '3.0';

export const tourSteps: DriveStep[] = [
  {
    element: '[data-tour="welcome"]',
    popover: {
      title: '👋 Welcome to Fork It!',
      description: `
        <div style="margin-bottom: 12px;">Discover the best dishes near you, voted by the community. Let's take a quick tour!</div>
        <label style="display: flex; align-items: center; gap: 8px; cursor: pointer; padding: 8px 0; font-size: 13px; color: rgba(255,255,255,0.7);">
          <input type="checkbox" id="tour-skip-checkbox" style="width: 16px; height: 16px; accent-color: #cfef00; cursor: pointer;" />
          Don't show this again
        </label>
      `,
      side: 'bottom',
      align: 'center',
    },
  },
  {
    element: '[data-tour="mode-switch"]',
    popover: {
      title: '🍽️ Eat Out or Eat In?',
      description: 'Toggle between restaurant dishes (dine-in) and takeaway/delivery options. The chart updates instantly!',
      side: 'bottom',
      align: 'center',
    },
  },
  {
    element: '[data-tour="dish-card"]',
    popover: {
      title: '🏆 Top Dishes Ranked',
      description: 'Each card shows a community-ranked dish. The dish name is at the top, with the restaurant name below it.',
      side: 'bottom',
      align: 'center',
    },
  },
  {
    element: '[data-tour="dish-card"]',
    popover: {
      title: '👆 Card Interactions',
      description: '<strong>Tap the photo</strong> to open the dish gallery. <strong>Tap anywhere else</strong> to expand the card and see more details.',
      side: 'bottom',
      align: 'center',
    },
  },
  {
    element: '[data-tour="vote-up"]',
    popover: {
      title: '🔥 Vote for Your Favorites',
      description: 'Love this dish? Upvote it! Your votes help rank the best food in your area.',
      side: 'left',
      align: 'center',
    },
  },
  {
    element: '[data-tour="fab-create"]',
    popover: {
      title: '➕ Share Your Finds',
      description: 'Tap here to submit a new dish, post a Snap (photo), or share a Drool (video).',
      side: 'top',
      align: 'center',
    },
  },
  {
    element: '[data-tour="feed-tab"]',
    popover: {
      title: '🎬 Discover the Feed',
      description: 'Swipe through Snaps (photos) and Drools (videos) from the community. Toggle between them at the top!',
      side: 'top',
      align: 'center',
    },
  },
  {
    element: '[data-tour="drips-tab"]',
    popover: {
      title: '💧 Drips — Your Activity Feed',
      description: 'See votes, submissions, and social activity from you and the people you follow.',
      side: 'top',
      align: 'center',
    },
  },
];

export const tourConfig = {
  showProgress: true,
  showButtons: ['next', 'previous', 'close'] as ('next' | 'previous' | 'close')[],
  nextBtnText: 'Next →',
  prevBtnText: '← Back',
  doneBtnText: 'Got it!',
  progressText: '{{current}} of {{total}}',
  animate: true,
  smoothScroll: true,
  allowClose: true,
  overlayClickNext: false,
  stagePadding: 8,
  stageRadius: 12,
  disableActiveInteraction: false,
  onPopoverRender: (popover: any, opts: { state: any }) => {
    // Add listener for skip checkbox on first step
    setTimeout(() => {
      const checkbox = document.getElementById('tour-skip-checkbox') as HTMLInputElement;
      if (checkbox) {
        checkbox.addEventListener('change', () => {
          if (checkbox.checked) {
            // The TourContext will handle this via a custom event
            window.dispatchEvent(new CustomEvent('tour-skip-requested'));
          }
        });
      }
    }, 100);
  },
};
